import {Button, Modal} from "antd";
import React from "react";

interface HelpModalProps {
    readonly isOpen: boolean
    readonly close: () => void
    readonly confirm: () => void
    readonly cost: number
}

export const EnrollmentConfirmModal = (props: HelpModalProps) => {
    return <Modal title="Conferma pagamento" open={props.isOpen} onCancel={props.close} footer={[
        <Button key="help-modal-cancel-button" type="default" onClick={props.close}>
            Cancella
        </Button>,
        <Button key="help-modal-confirm-button" type="primary" onClick={props.confirm}>
            Conferma
        </Button>
    ]}>
        <div>
            <h5>
                Il costo totale dei nuovi tesseramenti è di: {props.cost}
            </h5>
            <p>
                Confermando, sarai reindirizzato verso il flusso di pagamento.
            </p>
        </div>
    </Modal>
}